import { connect } from 'react-redux'

import { doUpdateTicketSearchQuery } from 'actions/search'

import { selectCurrentCommittedTicketSearchQueryCurrentPart } from 'selectors/search/base'
import { selectTicketSearchSuggestions } from 'selectors/search_suggestions'
import { selectIsFreeFormSearch } from 'selectors/search'

import TicketListHeader from './view'

const select = state => {
  return {
    currentPart: selectCurrentCommittedTicketSearchQueryCurrentPart(state),
    isFreeFormSearch: selectIsFreeFormSearch(state),
    suggestions: selectTicketSearchSuggestions(state),
  }
}

const perform = {
  doUpdateTicketSearchQuery,
}

export default connect(select, perform)(TicketListHeader)
